import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { Icon } from 'ui';

const Button = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  max-width: 70px;
  ${p => p.borderLeft && `border-left: 1px solid ${p.theme.colors.border}`};
  border-bottom: 1px solid ${p => p.theme.colors.border};
  height: ${p => p.theme.header.height};
  color: white;
  background-color: ${p => p.theme.colors.theme};
  cursor: pointer;
  &:hover {
    background-color: rgba(255, 255, 255, 0.5);
  }
`;

const HoverIcon = styled(Icon)`
  font-size: 16px;
  color: white;
  ${Button}:hover & {
    color: white;
  }
`;

const Text = styled.span`
  font-size: 11px;
  line-height: 11px;
  width: 60px;
  word-wrap: break-word;
  text-transform: uppercase;
`;

const HeaderButton = ({ className, icon, text, children, borderLeft = false, onClick, light }) =>
  <Button
    data-test-id={`header-button-${text?.replace(/\s+/g, '-')?.toLowerCase()}`}
    className={className}
    borderLeft={borderLeft}
    onClick={onClick}
  >
    <HoverIcon light={light} type={icon} marginBottom />
    {children}
    <Text>{text}</Text>
  </Button>;
HeaderButton.propTypes = {
  icon: PropTypes.string.isRequired,
  text: PropTypes.string,
  children: PropTypes.element,
  className: PropTypes.string,
  borderLeft: PropTypes.bool,
  onClick: PropTypes.func,
  light: PropTypes.bool,
};

export default HeaderButton;
